/* eslint-disable import/prefer-default-export */
import window from '../shared/window';

let previousFrame: HTMLIFrameElement | null = null;
export function downloadFile(uri: string) {
  const iframe = window.document.createElement('iframe');
  iframe.src = uri;
  iframe.setAttribute('style', 'display: none');
  if (previousFrame) {
    window.document.body.removeChild(previousFrame);
  }
  previousFrame = iframe;
  window.document.body.append(iframe);
}